import apiClient from "@/services/ApiClient";

// Query string with the parent context of child CRUDs (e.g. { cliente_id: 3 })
function contextQuery(params) {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") query.append(key, value);
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : "";
}

/**
 * Actions for CRUDs paginated server side (components/crud_md).
 * options: { page, itemsPerPage, sortBy[], sortDesc[], globalFilter, criteria[] }
 */
export function crudMdActions(serviceName) {
  return {
    crudMd: true,
    getListHeaders(params) {
      return apiClient.get(`/${serviceName}/headers${contextQuery(params)}`);
    },
    getListItems(options, params) {
      return apiClient.post(`/${serviceName}/items${contextQuery(params)}`, options);
    },
    exportExcelItems(options, params) {
      return apiClient.post(`/${serviceName}/items/export${contextQuery(params)}`, options, {
        responseType: "blob",
      });
    },
    saveColumnsConfig(crudName, headers) {
      return apiClient.post("/crud-configurations/save-columns", {
        name: crudName,
        data: headers
          .filter(header => header.value !== "actions")
          .map(({ value, visible, width }) => ({ value, visible, width })),
      });
    },
  };
}
